import sortBy from 'lodash.sortby';

import { apiNames, get, fetchQuery } from '@general/api/shared';

export const url = 'suffixes';
const fetchRequest = () => get(apiNames.MEMBERSHIP, url);

// {02d9023d-5d10-ea11-a813-000d3a8b659d: "Ms.", ...}
export const suffixesToOptions = data => {
    const items = [];
    for (const [key, value] of Object.entries(data)) {
        if (!items.find(i => i.value === value)) {
            items.push({ label: value, value });
        }
    }
    return sortBy(items, 'label');
};

export const getSuffixes = ({ transformData }) => fetchQuery({ fetchRequest, transformData });
